(function () {
  var STORAGE_KEY = 'sp_browsing_history';
  var MAX_HISTORY = 20;

  // Theme này expose window.theme.pageType = 'product' trên product page
  var isProduct = (
    (typeof window.theme !== 'undefined' && window.theme.pageType === 'product')
    || location.pathname.indexOf('/products/') !== -1
  );

  if (!isProduct) return;

  // Lấy handle từ URL: /products/{handle}
  var match = location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? match[1] : '';

  if (!handle) return;

  try {
    var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!Array.isArray(stored)) stored = [];

    // Xoá nếu đã tồn tại để đưa lên đầu
    stored = stored.filter(function (h) { return h !== handle; });
    stored.unshift(handle);

    // Giới hạn số lượng
    if (stored.length > MAX_HISTORY) stored = stored.slice(0, MAX_HISTORY);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch (e) {}
})();

(() => {
function initProductCardHeights() {
  const figures = document.querySelectorAll('.product-card__figure');

  figures.forEach((figure) => {
    const media = figure.querySelector('.product-card__media');
    if (!media) return;

    // Tìm lên product-card (parent hoặc closest)
    const card = figure.closest('product-card') || figure.closest('.product-card');
    if (!card) return;

    const updateHeight = () => {
      const height = media.getBoundingClientRect().height;
      card.style.setProperty('--product-card__media-height', `${height}px`);
    };

    updateHeight();

    const ro = new ResizeObserver(updateHeight);
    ro.observe(media);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCardHeights);
} else {
  initProductCardHeights();
}
})();